<template>
  <Roles />
</template>

<script>
  import Roles from "../../../components/_management/_roles/index.vue"

  export default {
    name: "RolesViews",
    components: {
      Roles,
    },
  }
</script>